import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { GiftsBenefitMetadataExtension } from './extension/gifts-benefit-metadata.extension';

export { GiftsDialog } from './GiftsList/GiftsDialog';
export { GiftsList } from './GiftsList/GiftsList';
EXTENSIONS.registerExtension(
  new ExtensionBuilder('gifts').add(BenefitMetadataExtensionInterface, new GiftsBenefitMetadataExtension()).build(),
);
